export enum WorksessionType {
  Procedure = 1,
  Consult = 2,
  Estimate = 4
}
